export const CurrencyName = {
  integerValue: 'tJOY',
} as const
